export const MasterModule = "MasterModule/" as const;
export const ShowDialog = "ShowDialog" as const;
